module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-orgchart-js",
    attrs: {
      "name": "demo-orgchart-js"
    }
  }, [_c('div', {
    attrs: {
      "id": "chart-container"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14412ceb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoOrgchartJs.vue
// module id = 3571
// module chunks = 1